export const D2SeasonInfo: Record<
  number,
  {
    DLCName: string;
    seasonName: string;
    seasonTag: string;
    season: number;
    maxLevel: number;
    powerFloor: number;
    softCap: number;
    powerfulCap: number;
    pinnacleCap: number;
    releaseDate: string;
    resetTime: string;
    numWeeks: number;
    episode?: number;
  }
> = {
  1: {
    DLCName: 'Red War',
    seasonName: 'Red War',
    seasonTag: 'redwar',
    season: 1,
    maxLevel: 20,
    powerFloor: 0,
    softCap: 285,
    powerfulCap: 300,
    pinnacleCap: 300,
    releaseDate: '2017-09-06',
    resetTime: '09:00:00Z',
    numWeeks: 13,
  },
  2: {
    DLCName: 'Curse of Osiris',
    seasonName: 'Curse of Osiris',
    seasonTag: 'osiris',
    season: 2,
    maxLevel: 25,
    powerFloor: 0,
    softCap: 320,
    powerfulCap: 330,
    pinnacleCap: 330,
    releaseDate: '2017-12-05',
    resetTime: '17:00:00Z',
    numWeeks: 22,
  },
  3: {
    DLCName: 'Warmind',
    seasonName: 'Resurgence',
    seasonTag: 'warmind',
    season: 3,
    maxLevel: 30,
    powerFloor: 0,
    softCap: 340,
    powerfulCap: 380,
    pinnacleCap: 380,
    releaseDate: '2018-05-08',
    resetTime: '18:00:00Z',
    numWeeks: 17,
  },
  4: {
    DLCName: 'Forsaken',
    seasonName: 'Season of the Outlaw',
    seasonTag: 'outlaw',
    season: 4,
    maxLevel: 50,
    powerFloor: 0,
    softCap: 500,
    powerfulCap: 600,
    pinnacleCap: 600,
    releaseDate: '2018-09-04',
    resetTime: '17:00:00Z',
    numWeeks: 12,
  },
  5: {
    DLCName: 'Black Armory',
    seasonName: 'Season of the Forge',
    seasonTag: 'forge',
    season: 5,
    maxLevel: 50,
    powerFloor: 0,
    softCap: 500,
    powerfulCap: 650,
    pinnacleCap: 650,
    releaseDate: '2018-11-27',
    resetTime: '17:00:00Z',
    numWeeks: 14,
  },
  6: {
    DLCName: "Joker's Wild",
    seasonName: 'Season of the Drifter',
    seasonTag: 'drifter',
    season: 6,
    maxLevel: 50,
    powerFloor: 0,
    softCap: 500,
    powerfulCap: 700,
    pinnacleCap: 700,
    releaseDate: '2019-03-05',
    resetTime: '17:00:00Z',
    numWeeks: 13,
  },
  7: {
    DLCName: 'Penumbra',
    seasonName: 'Season of Opulence',
    seasonTag: 'opulence',
    season: 7,
    maxLevel: 50,
    powerFloor: 0,
    softCap: 500,
    powerfulCap: 750,
    pinnacleCap: 750,
    releaseDate: '2019-06-04',
    resetTime: '17:00:00Z',
    numWeeks: 17,
  },
  8: {
    DLCName: 'Shadowkeep',
    seasonName: 'Season of the Undying',
    seasonTag: 'undying',
    season: 8,
    maxLevel: 50,
    powerFloor: 750,
    softCap: 900,
    powerfulCap: 950,
    pinnacleCap: 960,
    releaseDate: '2019-10-01',
    resetTime: '17:00:00Z',
    numWeeks: 10,
  },
  9: {
    DLCName: '',
    seasonName: 'Season of Dawn',
    seasonTag: 'dawn',
    season: 9,
    maxLevel: 50,
    powerFloor: 750,
    softCap: 900,
    powerfulCap: 960,
    pinnacleCap: 970,
    releaseDate: '2019-12-10',
    resetTime: '17:00:00Z',
    numWeeks: 13,
  },
  10: {
    DLCName: '',
    seasonName: 'Season of the Worthy',
    seasonTag: 'worthy',
    season: 10,
    maxLevel: 50,
    powerFloor: 750,
    softCap: 950,
    powerfulCap: 1000,
    pinnacleCap: 1010,
    releaseDate: '2020-03-10',
    resetTime: '17:00:00Z',
    numWeeks: 13,
  },
  11: {
    DLCName: '',
    seasonName: 'Season of Arrivals',
    seasonTag: 'arrivals',
    season: 11,
    maxLevel: 50,
    powerFloor: 750,
    softCap: 1000,
    powerfulCap: 1050,
    pinnacleCap: 1060,
    releaseDate: '2020-06-09',
    resetTime: '17:00:00Z',
    numWeeks: 22,
  },
  12: {
    DLCName: 'Beyond Light',
    seasonName: 'Season of the Hunt',
    seasonTag: 'hunt',
    season: 12,
    maxLevel: 50,
    powerFloor: 1050,
    softCap: 1200,
    powerfulCap: 1250,
    pinnacleCap: 1260,
    releaseDate: '2020-11-10',
    resetTime: '17:00:00Z',
    numWeeks: 13,
  },
  13: {
    DLCName: '',
    seasonName: 'Season of the Chosen',
    seasonTag: 'chosen',
    season: 13,
    maxLevel: 50,
    powerFloor: 1100,
    softCap: 1250,
    powerfulCap: 1300,
    pinnacleCap: 1310,
    releaseDate: '2021-02-09',
    resetTime: '17:00:00Z',
    numWeeks: 13,
  },
  14: {
    DLCName: '',
    seasonName: 'Season of the Splicer',
    seasonTag: 'splicer',
    season: 14,
    maxLevel: 50,
    powerFloor: 1100,
    softCap: 1250,
    powerfulCap: 1310,
    pinnacleCap: 1320,
    releaseDate: '2021-05-11',
    resetTime: '17:00:00Z',
    numWeeks: 15,
  },
  15: {
    DLCName: '',
    seasonName: 'Season of the Lost',
    seasonTag: 'lost',
    season: 15,
    maxLevel: 50,
    powerFloor: 1100,
    softCap: 1250,
    powerfulCap: 1320,
    pinnacleCap: 1330,
    releaseDate: '2021-08-24',
    resetTime: '17:00:00Z',
    numWeeks: 26,
  },
  16: {
    DLCName: 'Witch Queen',
    seasonName: 'Season of the Risen',
    seasonTag: 'risen',
    season: 16,
    maxLevel: 50,
    powerFloor: 1350,
    softCap: 1500,
    powerfulCap: 1550,
    pinnacleCap: 1560,
    releaseDate: '2022-02-22',
    resetTime: '17:00:00Z',
    numWeeks: 13,
  },
  17: {
    DLCName: '',
    seasonName: 'Season of the Haunted',
    seasonTag: 'haunted',
    season: 17,
    maxLevel: 50,
    powerFloor: 1350,
    softCap: 1510,
    powerfulCap: 1560,
    pinnacleCap: 1570,
    releaseDate: '2022-05-24',
    resetTime: '17:00:00Z',
    numWeeks: 13,
  },
  18: {
    DLCName: '',
    seasonName: 'Season of Plunder',
    seasonTag: 'plunder',
    season: 18,
    maxLevel: 50,
    powerFloor: 1350,
    softCap: 1520,
    powerfulCap: 1570,
    pinnacleCap: 1580,
    releaseDate: '2022-08-23',
    resetTime: '17:00:00Z',
    numWeeks: 15,
  },
  19: {
    DLCName: '',
    seasonName: 'Season of the Seraph',
    seasonTag: 'seraph',
    season: 19,
    maxLevel: 50,
    powerFloor: 1350,
    softCap: 1530,
    powerfulCap: 1580,
    pinnacleCap: 1590,
    releaseDate: '2022-12-06',
    resetTime: '17:00:00Z',
    numWeeks: 12,
  },
  20: {
    DLCName: 'Lightfall',
    seasonName: 'Season of Defiance',
    seasonTag: 'defiance',
    season: 20,
    maxLevel: 50,
    powerFloor: 1600,
    softCap: 1750,
    powerfulCap: 1800,
    pinnacleCap: 1810,
    releaseDate: '2023-02-28',
    resetTime: '17:00:00Z',
    numWeeks: 12,
  },
  21: {
    DLCName: '',
    seasonName: 'Season of the Deep',
    seasonTag: 'deep',
    season: 21,
    maxLevel: 50,
    powerFloor: 1600,
    softCap: 1750,
    powerfulCap: 1800,
    pinnacleCap: 1810,
    releaseDate: '2023-05-23',
    resetTime: '17:00:00Z',
    numWeeks: 13,
  },
  22: {
    DLCName: '',
    seasonName: 'Season of the Witch',
    seasonTag: 'witch',
    season: 22,
    maxLevel: 50,
    powerFloor: 1600,
    softCap: 1750,
    powerfulCap: 1800,
    pinnacleCap: 1810,
    releaseDate: '2023-08-22',
    resetTime: '17:00:00Z',
    numWeeks: 14,
  },
  23: {
    DLCName: '',
    seasonName: 'Season of the Wish',
    seasonTag: 'wish',
    season: 23,
    maxLevel: 50,
    powerFloor: 1600,
    softCap: 1750,
    powerfulCap: 1800,
    pinnacleCap: 1810,
    releaseDate: '2023-11-28',
    resetTime: '17:00:00Z',
    numWeeks: 27,
  },
  24: {
    DLCName: 'The Final Shape',
    seasonName: 'Episode: Echoes',
    seasonTag: 'echoes',
    season: 24,
    maxLevel: 50,
    powerFloor: 1900,
    softCap: 1940,
    powerfulCap: 1990,
    pinnacleCap: 2000,
    releaseDate: '2024-06-04',
    resetTime: '17:00:00Z',
    numWeeks: 18,
    episode: 1,
  },
  25: {
    DLCName: 'Revenant',
    seasonName: 'Episode: Revenant',
    seasonTag: 'revenant',
    season: 25,
    maxLevel: 50,
    powerFloor: 1900,
    softCap: 1950,
    powerfulCap: 2000,
    pinnacleCap: 2010,
    releaseDate: '2024-10-08',
    resetTime: '17:00:00Z',
    numWeeks: 17,
    episode: 2,
  },
  26: {
    DLCName: 'Heresy',
    seasonName: 'Episode: Heresy',
    seasonTag: 'heresy',
    season: 26,
    maxLevel: 50,
    powerFloor: 1900,
    softCap: 1960,
    powerfulCap: 2010,
    pinnacleCap: 2020,
    releaseDate: '2025-02-04',
    resetTime: '17:00:00Z',
    numWeeks: 23,
    episode: 3,
  },
  27: {
    DLCName: 'Edge of Fate',
    seasonName: 'Reclamation',
    seasonTag: 'reclamation',
    season: 27,
    maxLevel: 50,
    powerFloor: 10,
    softCap: 200,
    powerfulCap: 500,
    pinnacleCap: 550,
    releaseDate: '2025-07-15',
    resetTime: '17:00:00Z',
    numWeeks: 20,
  },
  28: {
    DLCName: 'Renegades',
    seasonName: 'Lawless',
    seasonTag: 'lawless',
    season: 28,
    maxLevel: 50,
    powerFloor: 10,
    softCap: 200,
    powerfulCap: 500,
    pinnacleCap: 550,
    releaseDate: '2025-12-02',
    resetTime: '17:00:00Z',
    numWeeks: 33,
  },
};

export const D2CalculatedSeason = 28;
export const D2SeasonPassActiveList = 0;
